<template>
  <div class="stepper">
    <div
      v-for="(step, index) in steps"
      v-bind:key="step.id"
      class="step"
      v-bind:class="{
        'step--active': step.active,
        'step--completed': checkIfCompleted(index)
      }">
      <div class="step__label">{{ index + 1 }}. {{ step.label }}</div>
      <div class="step__line"></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    steps: {
      type: Array,
      required: true,
    },
  },
  methods: {
    checkIfCompleted(index) {
      const activeStep = this.steps.findIndex(step => step.active);
      return index < activeStep;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../styles/vars/theme';
@import '../../styles/vars/typography';

.stepper {
  margin-top: 20px;
  display: flex;
  align-items: center;
  gap: 7px;
  padding-bottom: 32px;
}

.step {
  $self: &;
  width: 33.33%;

  &__label {
    font-size: 11px;
    font-weight: 500;
    color: $theme-color-gray-light;
  }

  &__line {
    margin-top: 5px;
    background: $theme-color-gray-light;
    height: 4px;
  }

  &--active {
    #{ $self }__label {
      color: $theme-color-primary;
    }

    #{ $self }__line {
      background: $theme-color-primary;
    }
  }

  &--completed {
    #{ $self }__label {
      color: $theme-color-primary-light;
    }

    #{ $self }__line {
      background: $theme-color-primary-light;
    }
  }
}
</style>
